import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';

import SubscriptionMenu from './components/SubscriptionMenu';
import CollectMenu from './components/CollectMenu';
import CommentPost from 'flarum/forum/components/CommentPost';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
// import ResponseItemsBtn from 'flarum/common/dlIndex/ResponseItemsBtn';

export default function addSubscriptionControls() {
  extend(DiscussionControls, 'userControls', function (items, discussion, context) {
    if (app.session.user && app.session.user != discussion.user()  && !(context instanceof DiscussionPage)) {
      const states = {
        none: { label: app.translator.trans('flarum-subscriptions.forum.discussion_controls.collect_button'), icon: 'far fa-star', save: 'follow' },
        follow: { label: app.translator.trans('flarum-subscriptions.forum.discussion_controls.uncollect_button'), icon: 'fas fa-star', save: null },
        ignore: { label: app.translator.trans('flarum-subscriptions.forum.discussion_controls.unignore_button'), icon: 'far fa-eye', save: null },
      };

      const subscription = discussion.subscription()===true?'follow':discussion.subscription() || 'none';

      items.add(
        'subscription',
        <Button icon={states[subscription].icon} onclick={() => this.subscription.bind(discussion)(() => this.refreshList(discussion))}>
          {states[subscription].label}
        </Button>
      );
    }
  });

  DiscussionControls.subscription = function (refreshCallback) {
    this.save({ subscription: !this.subscription() }).then(() => {
  
      AlertUtil.onSuccess(app, app.translator.trans(`dl-index.forum.permissions.success_${!this.subscription() ? 'not_collect_label' : 'collect_label'}`))
      m.redraw();
      if (refreshCallback) {
        refreshCallback();
      }
    });
    // discussion.save({ subscription: states[subscription].save }).then(AlertUtil.onSuccess(app, app.translator.trans(`dl-index.forum.permissions.success_${!subscription ? 'not_collect_label' : 'collect_label'}`)))
  };
  // extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
  //   if (app.session.user) {
  //     const discussion = this.discussion;

  //     items.add('subscription', <SubscriptionMenu discussion={discussion} />, 80);
  //   }
  // });
}
